import { __extends } from "tslib";
import { deserializeAws_restJson1_1CreateImportJobCommand, serializeAws_restJson1_1CreateImportJobCommand } from "../protocols/Aws_restJson1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var CreateImportJobCommand = /** @class */ (function (_super) {
    __extends(CreateImportJobCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CreateImportJobCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    CreateImportJobCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateImportJobCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1_1CreateImportJobCommand(input, context);
    };
    CreateImportJobCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1_1CreateImportJobCommand(output, context);
    };
    return CreateImportJobCommand;
}($Command));
export { CreateImportJobCommand };
//# sourceMappingURL=CreateImportJobCommand.js.map